import React, { useEffect } from 'react';

import { TableGridApiContextProvider } from '../../../../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import { api } from '../../../../../core/api';
import {
  useFilterDispatch,
  useFilterState,
} from '../../../shared/FinancialDataContext/FinancialDataContext';
import { FinancialDataContextActionTypes } from '../../../shared/FinancialDataContext/FinancialDataContext.types';
import { QueriesPanelTable } from '../QueriesPanelTable/QueriesPanelTable';

export const PredefinedFilters: React.FC = () => {
  const dispatch = useFilterDispatch();
  const { predefinedFilters, appliedFilters, predefinedFirstRender } = useFilterState();

  useEffect(() => {
    if (
      !predefinedFirstRender &&
      predefinedFilters &&
      predefinedFilters.length &&
      !appliedFilters.length
    ) {
      dispatch({
        type: FinancialDataContextActionTypes.Set,
        payload: predefinedFilters[0].searchRequest,
      });
      dispatch({
        type: FinancialDataContextActionTypes.SetPredefinedFirstRender,
        payload: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [predefinedFirstRender, predefinedFilters, appliedFilters]);

  return (
    <TableGridApiContextProvider>
      <QueriesPanelTable datasource={api.search.getPredefinedFilters} isPredefinedFilters={true} />
    </TableGridApiContextProvider>
  );
};
